import React from "react";

// Clean, recognizable silhouette of iconic landmarks, uniform-scaled (no distortion),
// sitting on a full-width baseline bar. Pakistan: Badshahi Mosque & Minar-e-Pakistan.
// Winnipeg: Manitoba Legislative Building (Golden Boy) & Esplanade Riel bridge.
export const Skyline = ({ className = "" }) => (
  <div className={`w-full leading-[0] ${className}`} data-testid="skyline-divider">
    <svg viewBox="0 0 1400 200" preserveAspectRatio="xMidYMax meet" className="block w-full h-[110px] md:h-[175px]">
      {/* filler buildings */}
      <g className="skyline-fill">
        <rect x="40" y="186" width="22" height="14" /><rect x="70" y="190" width="14" height="10" /><rect x="140" y="188" width="16" height="12" />
        <rect x="360" y="184" width="24" height="16" /><rect x="392" y="190" width="16" height="10" /><rect x="470" y="186" width="20" height="14" />
        <rect x="680" y="184" width="26" height="16" /><rect x="714" y="190" width="16" height="10" /><rect x="770" y="186" width="20" height="14" />
        <rect x="1030" y="188" width="18" height="12" /><rect x="1055" y="182" width="22" height="18" />
        <rect x="1300" y="186" width="20" height="14" /><rect x="1330" y="190" width="16" height="10" /><rect x="1360" y="188" width="14" height="12" />
      </g>

      {/* ===== Badshahi Mosque ===== */}
      <g className="skyline-fill" transform="translate(250,0)">
        <rect x="-72" y="176" width="144" height="24" />
        <rect x="-60" y="152" width="120" height="24" />
        {/* central onion dome */}
        <path d="M-26 152 C-30 130 -14 113 0 103 C14 113 30 130 26 152 Z" />
        <rect x="-1" y="94" width="2" height="9" /><circle cx="0" cy="101" r="2.5" />
        {/* side onion domes */}
        <path d="M-56 152 C-59 140 -49 129 -42 124 C-35 129 -25 140 -28 152 Z" />
        <path d="M28 152 C25 140 35 129 42 124 C49 129 59 140 56 152 Z" />
        {/* tall front minarets with chhatri */}
        <rect x="-70" y="120" width="8" height="80" /><rect x="-73" y="118" width="14" height="4" /><rect x="-68" y="106" width="4" height="12" />
        <path d="M-72 106 C-73 100 -69 94 -66 92 C-63 94 -59 100 -60 106 Z" /><rect x="-67" y="86" width="2" height="6" />
        <rect x="62" y="120" width="8" height="80" /><rect x="59" y="118" width="14" height="4" /><rect x="64" y="106" width="4" height="12" />
        <path d="M60 106 C59 100 63 94 66 92 C69 94 73 100 72 106 Z" /><rect x="65" y="86" width="2" height="6" />
        {/* rear shorter minarets */}
        <rect x="-49" y="134" width="6" height="66" /><path d="M-51 134 C-52 129 -48 124 -46 123 C-44 124 -40 129 -41 134 Z" />
        <rect x="43" y="134" width="6" height="66" /><path d="M41 134 C40 129 44 124 46 123 C48 124 52 129 51 134 Z" />
      </g>

      {/* ===== Minar-e-Pakistan ===== */}
      <g className="skyline-fill" transform="translate(580,0)">
        <rect x="-34" y="186" width="68" height="14" />
        <path d="M-22 186 L-22 166 Q0 146 22 166 L22 186 Z" />
        <path d="M-30 186 A8 10 0 0 1 -14 186 Z" /><path d="M14 186 A8 10 0 0 1 30 186 Z" />
        <rect x="-24" y="162" width="48" height="5" />
        <path d="M-14 162 L-10 118 L-6 84 L-2 70 L0 64 L2 70 L6 84 L10 118 L14 162 Z" />
        <rect x="-11" y="116" width="22" height="5" />
        <path d="M-6 72 C-7 66 -3 60 0 58 C3 60 7 66 6 72 Z" />
        <rect x="-1" y="48" width="2" height="10" /><circle cx="0" cy="46" r="3" />
      </g>

      {/* ===== Manitoba Legislative Building + Golden Boy ===== */}
      <g className="skyline-fill" transform="translate(900,0)">
        <rect x="-90" y="178" width="180" height="22" />
        <rect x="-90" y="170" width="28" height="8" /><rect x="62" y="170" width="28" height="8" />
        <rect x="-40" y="158" width="80" height="42" />
        <path d="M-24 158 L0 138 L24 158 Z" />
        <rect x="-20" y="158" width="3" height="18" /><rect x="-11" y="158" width="3" height="18" /><rect x="-2" y="158" width="3" height="18" /><rect x="7" y="158" width="3" height="18" /><rect x="16" y="158" width="3" height="18" />
        <rect x="-14" y="124" width="28" height="14" />
        <path d="M-14 124 C-14 102 -9 90 0 84 C9 90 14 102 14 124 Z" />
        <rect x="-4" y="74" width="8" height="10" /><path d="M-4 74 A4 4 0 0 1 4 74 Z" />
        {/* Golden Boy */}
        <rect x="-2" y="64" width="4" height="10" /><rect x="-1" y="52" width="2" height="12" /><circle cx="0" cy="50" r="3" />
        <path d="M1 55 L7 51 L8 53 L2 58 Z" /><circle cx="8.5" cy="51" r="2" />
      </g>

      {/* ===== Esplanade Riel bridge ===== */}
      <g transform="translate(1200,0)">
        <g className="skyline-fill">
          <rect x="-85" y="172" width="170" height="6" />
          <rect x="-73" y="178" width="6" height="22" /><rect x="67" y="178" width="6" height="22" />
          <path d="M-8 172 L6 80 L11 80 L-2 172 Z" /><rect x="5" y="70" width="4" height="10" />
        </g>
        <g className="skyline-stroke">
          <line x1="8" y1="84" x2="-70" y2="172" /><line x1="8" y1="84" x2="-50" y2="172" /><line x1="8" y1="84" x2="-30" y2="172" />
          <line x1="8" y1="84" x2="26" y2="172" /><line x1="8" y1="84" x2="46" y2="172" /><line x1="8" y1="84" x2="64" y2="172" />
        </g>
      </g>
    </svg>
    {/* full-width baseline bar */}
    <div className="w-full h-[12px] md:h-[18px] bg-forest -mt-px" />
  </div>
);

export const Crescent = ({ size = 64, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" className={className} data-testid="crescent-emblem">
    <circle cx="50" cy="50" r="48" fill="#12332a" stroke="#a8442f" strokeWidth="3" />
    <circle cx="50" cy="50" r="42" fill="none" stroke="#c9a24b" strokeWidth="1.5" />
    <path d="M62 28 A26 26 0 1 0 62 72 A20 20 0 1 1 62 28 Z" fill="#c9a24b" />
    <path d="M64 40 l3 7 7 1 -5 5 1 7 -6 -3 -6 3 1 -7 -5 -5 7 -1 z" fill="#c9a24b" />
  </svg>
);

// Ribbon banner for the tagline
export const Ribbon = ({ children, className = "" }) => (
  <div className={`relative inline-block ${className}`} data-testid="ribbon-banner">
    <div className="relative bg-cream border-2 border-forest px-8 md:px-14 py-2 md:py-3 shadow-block"
      style={{ clipPath: "polygon(0 0, 100% 0, calc(100% - 18px) 50%, 100% 100%, 0 100%, 18px 50%)" }}>
      <span className="tagline-italic text-forest text-2xl md:text-4xl font-semibold whitespace-nowrap">{children}</span>
    </div>
  </div>
);
